// USER LOGIn
export const USER_LOGIN_DETAILS = 'USER_LOGIN_DETAILS';

// User Listing
export const SET_LOADING = 'SET_LOADING';
export const GET_TEAM_LIST = 'GET_TEAM_LIST';
export const GET_TITLE_LIST = 'GET_TITLE_LIST';
export const GET_MEMBER_LIST = 'GET_MEMBER_LIST';
export const GET_MEMBER_BY_ID = 'GET_MEMBER_BY_ID';
export const GET_PROJECTS = 'GET_PROJECTS';
export const GET_PROJECT_BY_ID = 'GET_PROJECT_BY_ID';
export const GET_MEMBER_INVITE_LINK = 'GET_MEMBER_INVITE_LINK';
export const GET_DASHBOARD_TEAM_LIST = 'GET_DASHBOARD_TEAM_LIST';
export const GET_DASHBOARD_SUMMARY = 'GET_DASHBOARD_SUMMARY';
export const GET_DASHBOARD_TODAYS_ACTIVITY = 'GET_DASHBOARD_TODAYS_ACTIVITY';
export const GET_DASHBOARD_ACTIVITY = 'GET_DASHBOARD_ACTIVITY';
export const GET_DASHBOARD_PROJECT_LIST = 'GET_DASHBOARD_PROJECT_LIST';
export const GET_DASHBOARD_TASK_LIST = 'GET_DASHBOARD_TASK_LIST';
export const GET_DASHBOARD_TASK_SUMMARY = 'GET_DASHBOARD_TASK_SUMMARY';
export const GET_DASHBOARD_MEMBER_SUMMARY = 'GET_DASHBOARD_MEMBER_SUMMARY';
export const GET_DASHBOARD_SCREENSHOT = 'GET_DASHBOARD_SCREENSHOT';
export const GET_DASHBOARD_TOP_MEMBERS = 'GET_DASHBOARD_TOP_MEMBERS';
export const GET_DASHBOARD_MISSED_DEAD = 'GET_DASHBOARD_MISSED_DEAD';
export const GET_DASHBOARD_APPROACHING_DEAD = 'GET_DASHBOARD_APPROACHING_DEAD';
export const GET_REPORTS_TRACKED_HOURS = 'GET_REPORTS_TRACKED_HOURS';
export const GET_REPORTS_TRACKED_HOURS_MINUTE_WISE =
  'GET_REPORTS_TRACKED_HOURS_MINUTE_WISE';
export const GET_REPORTS_TRACKED_HOURS_IDLE_MINUTE_WISE =
  'GET_REPORTS_TRACKED_HOURS_IDLE_MINUTE_WISE';
export const GET_REPORTS_ACTIVITY_LEVEL = 'GET_REPORTS_ACTIVITY_LEVEL';
export const GET_REPORTS_ATTENDANCE = 'GET_REPORTS_ATTENDANCE';
export const GET_REPORTS_ATTENDANCE_MINUTE_WISE =
  'GET_REPORTS_ATTENDANCE_MINUTE_WISE';
export const GET_REPORTS_ATTENDANCE_IDLE_MINUTE_WISE =
  'GET_REPORTS_ATTENDANCE_IDLE_MINUTE_WISE';
export const GET_PROJECT_TASK_LIST = 'GET_PROJECT_TASK_LIST';
export const GET_PROJECT_TASK_BY_ID = 'GET_PROJECT_TASK_BY_ID';
export const GET_MONITORING_MEMBER = 'GET_MONITORING_MEMBER';
export const GET_MONITORING_PROJECT = 'GET_MONITORING_PROJECT';
export const GET_MONITORING_DAILY_ACTIVITY = 'GET_MONITORING_DAILY_ACTIVITY';
export const GET_INTERNET_SPEED_LOCATION = 'GET_INTERNET_SPEED_LOCATION';
export const GET_INTERNET_SPEED_LOCATION_SUMMARY =
  'GET_INTERNET_SPEED_LOCATION_SUMMARY';
export const GET_MONITORING_SCREENSHOTS = 'GET_MONITORING_SCREENSHOTS';
export const GET_REALTIME_LIST = 'GET_REALTIME_LIST';
export const GET_REALTIME_MEMBER_LIST = 'GET_REALTIME_MEMBER_LIST';
export const GET_REALTIME_PROJECT_LIST = 'GET_REALTIME_PROJECT_LIST';
export const GET_HOLIDAY__LIST = 'GET_HOLIDAY__LIST';
export const GET_HOLIDAY_BY_ID = 'GET_HOLIDAY_BY_ID';
export const GET_LEAVE_LIST = 'GET_LEAVE_LIST';
export const GET_LEAVE_POLICY = 'GET_LEAVE_POLICY';
export const GET_LEAVE_POLICY_BY_ID = 'GET_LEAVE_POLICY_BY_ID';
export const GET_LEAVE_BALANCE = 'GET_LEAVE_BALANCE';
export const GET_TIMESHEET_MEMBER = 'GET_TIMESHEET_MEMBER';
export const GET_TIMESHEET = 'GET_TIMESHEET';
export const GET_TIMESHEET_TASK_LIST = 'GET_TIMESHEET_TASK_LIST';
export const GET_TIMESHEET_PROJECT_LIST = 'GET_TIMESHEET_PROJECT_LIST';
export const GET_TIMEEDITOR_LIST = 'GET_TIMEEDITOR_LIST';
export const GET_ARCHIVED_USER = 'GET_ARCHIVED_USER';
export const GET_ONBOARD_USER = 'GET_ONBOARD_USER';
export const GET_ONBOARD_STATUS = 'GET_ONBOARD_STATUS';
export const GET_ONBOARD_MEMBERS_LIST = 'GET_ONBOARD_MEMBERS_LIST';
export const GET_ONBOARD_TEAMS_LIST = 'GET_ONBOARD_TEAMS_LIST';
export const GET_SCREENSHOT_DETAILS = 'GET_SCREENSHOT_DETAILS';
export const GET_SCHEDULE_REPORT_LIST = 'GET_SCHEDULE_REPORT_LIST';
export const GET_SCHEDULE_REPORT_BYID = 'GET_SCHEDULE_REPORT_BYID';
export const GET_TIMEZONE_LIST = 'GET_TIMEZONE_LIST';
export const GET_SHARE_REPORT = 'GET_SHARE_REPORT';
export const GET_SHARE_REPORT_PUBLIC = 'GET_SHARE_REPORT_PUBLIC';
export const GET_CHAT_EMPLOYEE_LIST = 'GET_CHAT_EMPLOYEE_LIST';
export const GET_TIME_REQUEST = 'GET_TIME_REQUEST';

export const GET_DOMAIN_DETAILS = 'GET_DOMAIN_DETAILS';
export const GET_TIMEZONES = 'GET_TIMEZONES';

// Super Admin type
export const GET_SUPERADMIN_DASHBOARD_DATA = 'GET_SUPERADMIN_DASHBOARD_DATA';
export const GET_DOMAIN_USER = 'GET_DOMAIN_USER';
export const GET_IMAGE_DATA = 'GET_IMAGE_DATA';
export const GET_DOMAIN_USER_BY_ID = 'GET_DOMAIN_USER_BY_ID';

// Employee
export const GET_WORKSPACE = 'GET_WORKSPACE';
export const GET_EMPLOYEE_DOMAIN = 'GET_EMPLOYEE_DOMAIN';
export const GET_EMPLOYEE_DASHBOARD = 'GET_EMPLOYEE_DASHBOARD';
export const GET_EMPLOYEE_WORKSPACE = 'GET_EMPLOYEE_WORKSPACE';
export const GET_EMPLOYEE_TIMESHEET_MEMBER = 'GET_EMPLOYEE_TIMESHEET_MEMBER';
export const GET_EMPLOYEE_TIMESHEET_PROJECT = 'GET_EMPLOYEE_TIMESHEET_PROJECT';
export const GET_EMPLOYEE_TIMESHEET_PROJECT_TASK =
  'GET_EMPLOYEE_TIMESHEET_PROJECT_TASK';
export const GET_EMPLOYEE_TIMESHEET = 'GET_EMPLOYEE_TIMESHEET';
export const GET_EMPLOYEE_PAST_ACTIVITIES = 'GET_EMPLOYEE_PAST_ACTIVITIES';
export const GET_EMPLOYEE_APP_USAGE = 'GET_EMPLOYEE_APP_USAGE';

export const GET_EMPLOYEE_PROJECTS = 'GET_EMPLOYEE_PROJECTS';
export const GET_EMPLOYEE_PROJECT_BY_ID = 'GET_EMPLOYEE_PROJECT_BY_ID';
export const GET_EMPLOYEE_PROJECT_TASK_LIST = 'GET_EMPLOYEE_PROJECT_TASK_LIST';
export const GET_EMPLOYEE_PROJECT_TASK_BY_ID =
  'GET_EMPLOYEE_PROJECT_TASK_BY_ID';
